import { ProductTypeName } from '@electricjs/core_entity-client';

export const DEVICE_PRODUCT_TYPES: ProductTypeName[] = [
  ProductTypeName.Laptop,
  ProductTypeName.Desktop,
  ProductTypeName.CellPhone,
  ProductTypeName.Tablets,
];

/** Product types that don't represent a physical object an employee can hand back. */
export const NON_PHYSICAL_PRODUCT_TYPES: ProductTypeName[] = [
  ProductTypeName.Service,
  ProductTypeName.Warranty,
  ProductTypeName.ShippingAndHandling,
];

/**
 * Order the offboarding Devices step walks the employee's assets in. Every
 * retrievable product type is listed explicitly so the order stays
 * predictable rather than depending on the order the API happens to return.
 */
export const DEVICE_RETRIEVAL_ORDER: ProductTypeName[] = [
  ProductTypeName.Laptop,
  ProductTypeName.Tablets,
  ProductTypeName.CellPhone,
  ProductTypeName.Desktop,
  ProductTypeName.Monitor,
  ProductTypeName.Accessory,
  ProductTypeName.Audio,
  ProductTypeName.Cable,
  ProductTypeName.Dock,
  ProductTypeName.Headphones,
  ProductTypeName.Keyboard,
  ProductTypeName.KeyboardMouse,
  ProductTypeName.Microphone,
  ProductTypeName.Miscellaneous,
  ProductTypeName.Mouse,
  ProductTypeName.OtherPhone,
  ProductTypeName.PowerAdapter,
  ProductTypeName.Video,
];

export const getDeviceRetrievalOrderIndex = (
  productType: ProductTypeName
): number => {
  const index = DEVICE_RETRIEVAL_ORDER.indexOf(productType);
  return index === -1 ? DEVICE_RETRIEVAL_ORDER.length : index;
};
